import Vue from 'vue'
import VueRouter from 'vue-router'
import LicenseCheck from '../views/LicenseCheck.vue'
import Home from '../views/Home.vue'
import Authorization from '../views/Authorization.vue'
import UploadVideo from '../views/UploadVideo.vue'
import VideoShare from '../views/VideoShare.vue'
import MaterialCleanup from '../views/MaterialCleanup.vue'
import MaterialDownload from '../views/MaterialDownload.vue'
import VideoTools from '../views/VideoTools.vue'
import WalletManagement from '../views/WalletManagement.vue'
import WalletMetadataManagement from '../views/WalletMetadataManagement.vue'
import DataOverview from '../views/DataOverview.vue'
import MaterialScanSummary from '../views/MaterialScanSummary.vue'
import VideoTrace from '../views/VideoTrace.vue'
import ExpressScan from '../views/ExpressScan.vue'
import ExpressAdmin from '../views/ExpressAdmin.vue'
import PlatformResources from '../views/PlatformResources.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'LicenseCheck',
    component: LicenseCheck,
    meta: { title: '登录授权' }
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: { title: '首页' }
  },
  {
    path: '/authorization',
    name: 'Authorization',
    component: Authorization,
    meta: { title: '视频上传' }
  },
  {
    path: '/upload-video',
    name: 'UploadVideo',
    component: UploadVideo,
    meta: { title: '上传视频' }
  },
  {
    path: '/video-share',
    name: 'VideoShare',
    component: VideoShare,
    meta: { title: '视频分享' }
  },
  {
    path: '/material-cleanup',
    name: 'MaterialCleanup',
    component: MaterialCleanup,
    meta: { title: '清理素材' }
  },
  {
    path: '/material-download',
    name: 'MaterialDownload',
    component: MaterialDownload,
    meta: { title: '素材下载' }
  },
  {
    path: '/video-tools',
    name: 'VideoTools',
    component: VideoTools,
    meta: { title: '视频工具' }
  },
  {
    path: '/wallet-management',
    name: 'WalletManagement',
    component: WalletManagement,
    meta: { title: '余额管理' }
  },
  {
    path: '/wallet-metadata-management',
    name: 'WalletMetadataManagement',
    component: WalletMetadataManagement,
    meta: { title: '钱包元数据管理' }
  },
  {
    path: '/data-overview',
    name: 'DataOverview',
    component: DataOverview,
    meta: { title: '数据概览' }
  },
  {
    path: '/material-scan-summary',
    name: 'MaterialScanSummary',
    component: MaterialScanSummary,
    meta: { title: '素材汇总' }
  },
  {
    path: '/video-trace',
    name: 'VideoTrace',
    component: VideoTrace,
    meta: { title: '视频溯源' }
  },
  {
    path: '/express-scan',
    name: 'ExpressScan',
    component: ExpressScan,
    meta: { title: '快递二维码识别' }
  },
  {
    path: '/express-admin',
    name: 'ExpressAdmin',
    component: ExpressAdmin,
    meta: { title: '售后快递管理' }
  },
  {
    path: '/platform-resources',
    name: 'PlatformResources',
    component: PlatformResources,
    meta: { title: '平台资料' }
  },
  {
    path: '/index',
    redirect: '/authorization'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.afterEach((to) => {
  const pageTitle = to.meta && to.meta.title ? `${to.meta.title} - 智千投` : '智千投'
  document.title = pageTitle
})

export default router
